type NetworkAvailability = {
  network: string;
  deposit: boolean;
  withdraw: boolean;
  status?: string;
  error?: string | null;
};

function networkTitle(item: NetworkAvailability): string {
  if (item.status === 'error') return item.error || item.network + ': ошибка проверки';
  const deposit = item.deposit ? 'ввод доступен' : 'ввод закрыт';
  const withdraw = item.withdraw ? 'вывод доступен' : 'вывод закрыт';
  return item.network + ': ' + deposit + ', ' + withdraw;
}

export function BalanceNetworkBadges({ networks }: { networks?: NetworkAvailability[] }) {
  const visible = (networks || []).filter(item => item.network);
  if (visible.length === 0) return <div className="balance-network-badges empty" aria-hidden="true" />;

  return (
    <div className="balance-network-badges">
      {visible.map(item => (
        <span
          key={item.network}
          className={'balance-network-badge' + (item.status === 'error' ? ' error' : '')}
          title={networkTitle(item)}
        >
          <span>{item.network}</span>
          <span className={item.deposit ? 'ok' : 'off'}>↓{item.deposit ? '✓' : '×'}</span>
          <span className={item.withdraw ? 'ok' : 'off'}>↑{item.withdraw ? '✓' : '×'}</span>
        </span>
      ))}
    </div>
  );
}
